module.exports = __webpack_public_path__ + "static/media/aithyia-2.2424b19c.jpg";